import { ArquivarAnaliseProjeto } from "./ArquivarAnaliseProjeto";

export default ArquivarAnaliseProjeto;